export default __webpack_public_path__ + "static/media/IRT_image_examples_v2.d37bc8e5.png";